import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useForm } from './FormManager';
import './FinalCTA.css';

const FinalCTA = () => {
  const { t } = useTranslation();
  const { openGeneralForm } = useForm();
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const ctaRef = useRef(null);
  
  // Animation on scroll
  useEffect(() => {
    const section = sectionRef.current;
    const content = contentRef.current;
    const cta = ctaRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          setTimeout(() => content.classList.add('visible'), 150);
          setTimeout(() => cta.classList.add('visible'), 300);
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="final-cta" ref={sectionRef}>
      <div className="final-cta-background">
        <div className="final-cta-shape final-cta-shape-1"></div>
        <div className="final-cta-shape final-cta-shape-2"></div>
        <div className="final-cta-shape final-cta-shape-3"></div>
      </div>
      
      <div className="container">
        <div className="final-cta-content" ref={contentRef}>
          <h2 className="final-cta-title">
            {t('finalCtaTitle')}
          </h2>
          <p className="final-cta-description">
            {t('finalCtaDescription')}
          </p>
        </div>
        
        <div className="final-cta-actions" ref={ctaRef}>
          <button className="cta-button" onClick={openGeneralForm}>
            Mehr Kunden gewinnen
          </button>
          {/* Secondary button hidden for now
          <button className="final-cta-button secondary">
            {t('finalCtaSecondary')}
          </button>
          */}
        </div>
        <div className="final-cta-note">
              <Link to="/contact" className="final-cta-link-note" aria-label={t('moreQuestionsAria')}>
                {t('moreQuestionsText')} 
              </Link>
            </div>
      </div>
    </section>
  );
};

export default FinalCTA;
